import React, { useContext, useReducer, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Collapse, Navbar } from 'reactstrap';
import { Global } from '../../App';
import LangSelector from '../GlobalSetting/LangSelector';
import ChangeFontSize from '../GlobalSetting/ChangeFontSize';
import cls from 'classnames';
import './Header.scss';
import '../../Resource/scss/icon.scss';
import logo_pc from '../../Resource/image/icons/img_logo_pc.png';
import logo_mobile from '../../Resource/image/icons/img_logo_mobile.png';
// api
import { getLangOption } from '../../Api/GetLangOption';
import { useRef } from 'react';
import { useState } from 'react';
import { useMemo } from 'react';
const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

/**
 * @param {object} props
 */
function Header(props) {
  const headerRef = useRef()
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    menu: true,
    headerMode: userType(),
    langOption: []
  });

  function userType() {
    let pathname = props.location.pathname.replace(/<[^>]*>|/g, '');
    if (pathname.toLowerCase().indexOf('staff') > -1) {
      return 'staff';
    } else {
      return 'customer';
    }
  }
  const goToIndex = () => {
    if (state.headerMode === 'customer') {
      props.history.push('/');
      dispatchGlobal({ type: 'RESET' });
      dispatch({
        type: 'UPDATE_STATE',
        payload: [{ key: 'menu', val: false }]
      });
    } else if (state.headerMode === 'staff') {
      props.history.push('/staffCheckOrder');
      dispatchGlobal({ type: 'LOGOUT' });
      dispatch({
        type: 'UPDATE_STATE',
        payload: [{ key: 'menu', val: false }]
      });
    }
  };
  const resetStaff = () => {
    dispatchGlobal({
      type: 'UPDATE',
      payload: [
        {
          key: 'staffInfo',
          val: {
            currentCheckOrderStep: '1',
            currentTakeOrderStep: '1',
            checkOrderBranch: globalState.staffInfo.checkOrderBranch,
            checkOrderGroup: globalState.staffInfo.checkOrderGroup,
            checkOrderStaff: globalState.staffInfo.checkOrderStaff,
            checkOrderData: null,
            takeOrderData: null
          }
        }
      ]
    });
  };
  async function apiLangOption() {
    try {
      let res = await getLangOption();
      const { errCode, language } = res.data;
      if (errCode == 200) {
        const newLangOption = language.map(e => ({
          title: e.original_name,
          langType: e.id
        }));
        dispatch({
          type: 'UPDATE_STATE',
          payload: [{ key: 'langOption', val: newLangOption }]
        });
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/error');
      }
    } catch (err) {
      console.error('LangOption error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 403 }]
      });
      props.history.push('/error');
    }
  }

  useEffect(() => {
    apiLangOption();
  }, []);
  //
  const pcItems = () => {
    const { langType } = globalState;
    if (state.headerMode === 'customer')
      return (
        <div
          className={cls(
            'd-flex w100',
            globalState.langType === 'en'
              ? 'flex-column justify-content-center'
              : 'justify-content-center align-items-center'
          )}
        >
          <a
            className={cls(
              'header__items mt-5 mb-5',
              props.location.pathname === '/' ? 'header__items_active' : '',
              langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/');
              dispatchGlobal({ type: 'RESET' });
            }}
          >
            <i className="icn icn_menu_selected__pc" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id={`header.menuItems.order`} />
              </div>
            </div>
          </a>
          <a
            className={cls(
              'header__items mt-5 mb-5',
              props.location.pathname === '/showMenu'
                ? 'header__items_active'
                : '',
              langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/showMenu');
              dispatchGlobal({ type: 'RESET' });
            }}
          >
            <i className="icn icn_menu_selected__pc" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id={`header.menuItems.menu`} />
              </div>
            </div>
          </a>
        </div>
      );
    if (state.headerMode === 'staff')
      return (
        <div
          className={cls(
            'd-flex w100',
            globalState.langType === 'en'
              ? 'flex-column justify-content-center'
              : 'justify-content-center align-items-center'
          )}
        >
          <a
            className={cls(
              'header__items mt-5 mb-5',
              props.location.pathname === '/staffCheckOrder'
                ? 'header__items_active'
                : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/staffCheckOrder');
              resetStaff();
            }}
          >
            <i className="icn icn_menu_selected__pc" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id="header.menuItems.staffCheckOrder" />
              </div>
            </div>
          </a>
          <a
            className={cls(
              'header__items mt-5 mb-5',
              props.location.pathname === '/staffSearchOrder'
                ? 'header__items_active'
                : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/staffSearchOrder');
              resetStaff();
            }}
          >
            <i className="icn icn_menu_selected__pc" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id="header.menuItems.staffSearchOrder" />
              </div>
            </div>
          </a>
        </div>
      );
  };
  const mobileItems = () => {
    if (state.headerMode === 'customer') {
      return (
        <div
          className={cls(
            'd-flex w100',
            globalState.langType === 'en'
              ? 'flex-column justify-content-center'
              : 'justify-content-center align-items-center'
          )}
        >
          <div
            className={cls(
              'header__items',
              props.location.pathname === '/' ? 'header__items_active' : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/');
              dispatchGlobal({ type: 'RESET' });
            }}
          >
            <i className="icn icn_menu_selected__mobile" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id={`header.menuItems.order`} />
              </div>
            </div>
          </div>
          <div
            className={cls(
              'header__items',
              props.location.pathname === '/showMenu'
                ? 'header__items_active'
                : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/showMenu');
              dispatchGlobal({ type: 'RESET' });
            }}
          >
            <i className="icn icn_menu_selected__mobile" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id={`header.menuItems.menu`} />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (state.headerMode === 'staff') {
      return (
        <div
          className={cls(
            'd-flex w100',
            globalState.langType === 'en'
              ? 'flex-column justify-content-center'
              : 'justify-content-center align-items-center'
          )}
        >
          <div
            className={cls(
              'header__items',
              props.location.pathname === '/staffCheckOrder'
                ? 'header__items_active'
                : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/staffCheckOrder');
              resetStaff();
            }}
          >
            <i className="icn icn_menu_selected__mobile" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id="header.menuItems.staffCheckOrder" />
              </div>
            </div>
          </div>
          <div
            className={cls(
              'header__items',
              props.location.pathname === '/staffSearchOrder'
                ? 'header__items_active'
                : '',
              globalState.langType === 'en' ? 'header__items_hor' : ''
            )}
            onClick={() => {
              props.history.push('/staffSearchOrder');
              resetStaff();
            }}
          >
            <i className="icn icn_menu_selected__mobile" />
            <div className="header__items-option pt-5 text-nowrap">
              <div className="pl-3 pr-3">
                <FormattedMessage id="header.menuItems.staffSearchOrder" />
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (state.menu) {
      window.document.querySelector('body').style.overflow = 'hidden'
      return () => {
        window.document.querySelector('body').style.overflow = ''

      }
    }
  }, [state.menu])

  return (
    <div
      ref={headerRef}
      className={cls('header', state.menu ? 'header_active' : '')}
    // onClick={(e) => {
    //   if (state.menu && e.target === headerRef.current) {
    //     dispatch({
    //       type: 'UPDATE_STATE',
    //       payload: [{ key: 'menu', val: !state.menu }]
    //     });
    //   }
    // }}
    >
      {/* pc header */}
      <header className="header__pc">
        <a
          style={{
            backgroundImage: `url(${logo_pc})`
          }}
          className="icn icn_img_logo__pc header__pc__logo"
          onClick={() => goToIndex()}
        />
        <div className="header__pc__menu d-flex flex-column align-items-center">
          <LangSelector
            mode="pc"
            options={state.langOption}
            onClose={() => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [{ key: 'menu', val: false }]
              });
            }}
          />
          <a
            className="icn icn_ic_menu__pc header__pc__menu_toggle"
            onClick={() => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [{ key: 'menu', val: !state.menu }]
              });
            }}
          />
        </div>
        <div className="header__pc-nav">
          <Collapse className="header__pc-nav" isOpen={state.menu} navbar>
            <div className="d-flex flex-column p-5">
              <div className={cls('d-flex col-auto justify-content-center')}>
                {pcItems()}
              </div>
              {/* logout */}
              {(() => {
                const {
                  checkOrderBranch,
                  checkOrderGroup,
                  checkOrderStaff
                } = globalState.staffInfo;
                if (
                  state.headerMode === 'staff' &&
                  checkOrderBranch &&
                  checkOrderGroup &&
                  checkOrderStaff
                ) {
                  return (
                    <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                      <a className="link" onClick={() => goToIndex()}>
                        <FormattedMessage id="header.staffLogOut" />
                      </a>
                    </div>
                  );
                }
              })()}
            </div>
          </Collapse>
        </div>
      </header>
      {/* mobile header */}
      <header className="header__mobile">
        <Navbar className="header__mobile-nav" color="faded" light>
          <i
            style={{
              backgroundImage: `url(${logo_mobile})`
            }}
            className="icn icn_img_logo__mobile"
            onClick={() => goToIndex()}
          />
          <i
            className="icn icn_ic_menu__mobile"
            onClick={() => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [{ key: 'menu', val: !state.menu }]
              });
            }}
          />
          <Collapse className="w-100" isOpen={state.menu} navbar>
            <div className="d-flex flex-column">
              <div className="d-flex col-auto align-items-center justify-content-center mt-3 mb-3">
               
                {mobileItems()}
              </div>
              <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                <LangSelector
                  mode="mobile"
                  options={state.langOption}
                  onClose={() => {
                    dispatch({
                      type: 'UPDATE_STATE',
                      payload: [{ key: 'menu', val: false }]
                    });
                  }}
                />
              </div>
              {/* logout */}
              {(() => {
                const {
                  checkOrderBranch,
                  checkOrderGroup,
                  checkOrderStaff
                } = globalState.staffInfo;
                if (state.headerMode === 'customer') {
                  return (
                    <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                      <ChangeFontSize
                        onClose={() => {
                          dispatch({
                            type: 'UPDATE_STATE',
                            payload: [{ key: 'menu', val: false }]
                          });
                        }}
                      />
                    </div>
                  );
                } else if (
                  state.headerMode === 'staff' &&
                  checkOrderBranch &&
                  checkOrderGroup &&
                  checkOrderStaff
                ) {
                  return (
                    <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
                      <a className="link" onClick={() => goToIndex()}>
                        <FormattedMessage id="header.staffLogOut" />
                      </a>
                    </div>
                  );
                }
              })()}
            </div>
          </Collapse>
        </Navbar>
      </header>
    </div>
  );
}

// export default withRouter(NewHeader)
// 
export default () => null


// export default withRouter(Header);
